import React, { useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { updateExpenseEntryArchiveAsync, resetSelectedRecordObjectInState } from "./ExpenseEntryArchiveSlice";
import { ExpenseEntryArchiveInitialsForAdd, ExpenseEntryArchiveInitialsForUpdate } from "./interfaces/ExpenseEntryArchiveClass";
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from "../../../common/timeLiveFunction";
export const ExpenseEntryArchiveForm = (props: any) => {
    // const { t, oncloseModal } = props;
    // const [currentFieldsData, setCurrentFieldsData] = useState<any>(ExpenseEntryArchiveInitialsForAdd);
    // const { selectedRecord, isLoading } = useAppSelector((state) => state.expenseEntryArchive);
    // const dispatch = useAppDispatch();
    // const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const { t, oncloseModal } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ExpenseEntryArchiveInitialsForAdd);
    const { selectedRecord } = useAppSelector((state) => state.expenseEntryArchive);
    const dispatch = useAppDispatch();
     const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ExpenseEntryArchiveInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(ExpenseEntryArchiveInitialsForAdd);
        }
    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateExpenseEntryArchiveAsync(currentFieldsData))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    ShowToast("Entry(s) Updated Succesfully", 'Success', "success", "toast-top-right");
                    oncloseModal();
                }).catch((rejectedValueOrSerializedError) => {
                    oncloseModal();
                })
        }

    }
    return (
        <>

            <div className="modal drawer-overlay" style={{ display: 'block' }}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                            <h5 className="modal-title mainHeading">
                                {/* {t('Update Expense Entry Archive')} */}
                                {getValueFromResource('Update Expense Entry Archive',dispatch, t)}
                                 </h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                onClick={oncloseModal}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-1x"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className='row' >
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Submitted')} */}
                                        {getValueFromResource('Submitted',dispatch, t)}
                                        </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-15px w-30px" type="checkbox" checked={currentFieldsData.Submitted} id="Submitted" onChange={handleTextChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Approved')} */}
                                        {getValueFromResource('Approved',dispatch, t)}
                                        </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-15px w-30px" type="checkbox" checked={currentFieldsData.Approved} id="Approved" onChange={handleTextChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                onClick={oncloseModal}
                            >
                                {/* {t('Cancel')} */}
                                {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                            <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={handleSubmit} >
                                {/* {t('Save')} */}
                                {getValueFromResource('Save',dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
